import { ChevronLeft, X } from "lucide-react";
import { useRef } from "react";

import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { useGetBreakoutSessions } from "../api/get-breakout-sessions";

import { BreakoutSessionsList } from "./breakout-sessions-list";
import { CreateBreakoutSessionForm } from "./create-breakout-session.form";

export function BreakoutSessionsDrawer() {
  const setActiveTab = useVidyoStore((s) => s.moderationDrawer.setActiveTab);
  const closeExtendSessionDrawer = useVidyoStore(
    (s) => s.moderationDrawer.close,
  );
  const contentContainerRef = useRef<HTMLDivElement>(null);
  const sessionId = useVidyoStore((store) => store.sessionId);
  const {
    data: breakoutSessions,
    isLoading,
    isSuccess,
  } = useGetBreakoutSessions(sessionId);

  const hasBreakoutSessions = isSuccess && breakoutSessions.length > 0;
  return (
    <div className="flex h-full flex-col" ref={contentContainerRef}>
      <div className="flex items-center">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setActiveTab()}
          className="ml-2 mr-1"
        >
          <ChevronLeft className="size-4" />
        </Button>
        <p
          className="py-4 text-sm text-foreground"
          id="moderation-drawer-title"
        >
          Breakout Sessions
        </p>

        <Button
          variant="ghost"
          size="icon"
          onClick={closeExtendSessionDrawer}
          className="absolute right-2 top-2"
        >
          <X className="size-4" />
        </Button>
      </div>

      <Separator className="mb-4 bg-border" />
      <ScrollArea
        className={`h-[${contentContainerRef.current?.clientHeight}px] flex-1`}
      >
        {isLoading ? (
          <LoadingScreen />
        ) : hasBreakoutSessions ? (
          <BreakoutSessionsList />
        ) : (
          <CreateBreakoutSessionForm />
        )}
      </ScrollArea>
    </div>
  );
}
